/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosports3ColumnBannersData } from './hosports-3-column-banners.data';
import { IHosports3ColumnBannersProps } from './hosports-3-column-banners.props.autogenerated';

export interface IHosports3ColumnBannersViewProps extends IHosports3ColumnBannersProps<IHosports3ColumnBannersData> {

}

/**
 *
 * Hosports3ColumnBanners component
 * @extends {React.PureComponent<IHosports3ColumnBannersProps<IHosports3ColumnBannersData>>}
 */
class Hosports3ColumnBanners extends React.PureComponent<IHosports3ColumnBannersProps<IHosports3ColumnBannersData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default Hosports3ColumnBanners;
